import Icon from '@/components/snippets/icon/icon'

export function FilterCollapse({ label, children, activeFilterLabel, valueType = 'default' }) {
  const id = `filter-${label.toLowerCase().replace(/\s/g, '-')}`

  return (
    <x-modal
      data-id={id}
      className="group/filter flex flex-col border-b border-borders-default dropdown-modal"
      data-toggle-group="true"
    >
      <button
        className="flex items-center justify-between gap-x-0.75 min-h-[56px] px-margin py-0.5 text-left link-fade"
        data-modal-parent={id}
        data-modal-role="toggle"
        aria-label={label}
      >
        <span className="paragraph-s font-extended font-semibold flex flex-wrap items-center">
          <span>{label}</span>
          {activeFilterLabel ? (
            valueType === 'number' ? (
              <span>
                &nbsp;({activeFilterLabel})
              </span>
            ) : (
              <span>
                : <span className="text-type-black-secondary">{activeFilterLabel}</span>
              </span>
            )
          ) : null}
        </span>
        <div className="flex w-[10px] h-[5px] group-data-visible/filter:-rotate-180 transition-all children:size-full">
          <Icon id="chevron-down" />
        </div>
      </button>
      <div className="dropdown-content">
        <div className="overflow-hidden flex flex-col">{children}</div>
      </div>
    </x-modal>
  )
}
